import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"; 
gsap.registerPlugin(ScrollTrigger); 

export default class HomeText{

	constructor(el){

		this.el = el;

		this.elms = {			
			container 		: this.el,
			badge			: this.el.querySelector('[data-hometext-badge]'), 
			scrollingText	: this.el.querySelector('[data-hometext-scrolling-text]'), 
		}   

		this.init(); 

	}


	init(){  

		if(this.elms.scrollingText){
			
			let scrollingTextElm = this.elms.scrollingText;
			gsap.fromTo(
				scrollingTextElm,
				{ x: 0 },
				{
					scrollTrigger	: {
						trigger	: scrollingTextElm,
						scrub	: true,
						start	: "top bottom",
						end		: "bottom top"					
					},
					ease			: "linear",
					x				: window.outerWidth * -0.5,
				}
			);
		
		}		

		if(this.elms.badge){
			
			let badgeElm = this.elms.badge;

			gsap.fromTo(
				badgeElm,
				{
					rotation		: -25
				},
				{
					rotation		: 180,
					ease			: "none",
					scrollTrigger	: {
						trigger	: this.el,
						start	: "-=80%",
						end		: "+=100%",						
						scrub	: 1
					}
				}
			);



		}

	}

}